import React from 'react';
import get from 'lodash/get';
import { LazyImage } from 'project/lazy-image';
import { CourseToggleView } from 'components/course';
import LiveHoleWeather from './live-hole-weather';

class LiveHoleView extends React.Component {
    constructor(props) {
        super(props);

        this.contentToggleButton = {
            primaryContent: 'view green',
            changedView: 'view hole'
        };

        this.state = {
            primaryView: false
        };
    }

    toggleView = () => {
        this.setState({ primaryView: !this.state.primaryView });
    }

    render() {
        const { hole } = this.props;

        const yardage = get(hole, 'sitecoreData.holeYardage');
        let image = get(hole, 'sitecoreData.holeSrc');
        let green = get(hole, 'sitecoreData.greenSrc');

        if (this.state.primaryView) {
            image = get(hole, 'sitecoreData.greenSrc');
        }

        return (
            <div className="live-hole-view">
                <div className="live-hole-view__picture">
                    <LazyImage image={image} />
                </div>
                <div className="live-hole-view__container">
                    <LiveHoleWeather weather={hole.weather} />
                    <div className="live-hole-view__holes-content">
                        <div className="live-hole-view__holes-content-par">par {hole.par}</div>
                        <div className="live-hole-view__holes-content-yardage">{`yardage ${yardage}`}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LiveHoleView;
